import React from "react";
import { Link } from "react-router-dom";
import Logo from "../assets/logo1.png";
import { 
  FaFacebookF,
  FaTwitter,
  FaInstagram,
  FaYoutube,
  FaLinkedinIn,
  FaTelegramPlane,
  FaWhatsapp,
  FaPhone,
  FaEnvelope,
  FaMapMarkerAlt,
  FaClock,
  FaArrowRight,
  FaHeart,
  FaShieldAlt,
  FaWallet,
  FaShareAlt,
  FaProductHunt,
  FaUsers,
  FaTrophy,
  FaCar,
  FaGift,
  FaStore,
  FaTruck,
  FaMobile,
  FaHeadset,
  FaQrcode,
  FaGooglePlay,
  FaApple,
  FaRocket,
  FaStar,
  FaChartLine,
  FaCrown,
  FaGem,
  FaCoins,
  FaHandHoldingUsd,
  FaUniversity,
  FaCheckCircle
} from "react-icons/fa";

// Color palette based on ABM Group colors
const colors = {
  brightBlue: '#00A9EC',
  deepOrange: '#E06207',
  nearBlack: '#0E1306',
  green: '#018F2C',
  darkBrown: '#602005',
  burntOrange: '#A65007',
  lightOrange: '#EF9222',
  darkGreen: '#056619',
  reddishBrown: '#9C2E04',
  darkBlue: '#0067A1',
  skyBlue: '#0DC8F8',
  peachOrange: '#FDA653',
  navyBlue: '#023057',
  oliveBrown: '#604B0C',
  tealBlue: '#024D6E',
  pinkMagenta: '#A70756',
  goldenYellow: '#F3D71B',
  freshGreen: '#12B14A',
  lightGreen: '#55CB71',
  lightCyan: '#56E0F9'
};

function Footer() {
  const currentYear = new Date().getFullYear();

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <footer className="relative bg-white text-gray-800 border-t border-gray-200">

      {/* ===== MAIN FOOTER ===== */}
      <div className="container mx-auto px-6 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-8 max-w-7xl mx-auto">
          
          {/* Company Info - Column 1 */}
          <div className="lg:col-span-1">
            {/* Logo with ABM colors */}
            <div className="flex items-center gap-2 mb-4">
              <div className="relative group">
                <div className="absolute -inset-1 rounded-lg bg-[#05F1FF] opacity-70 blur"></div>
                <div className="relative p-1 bg-[#05F1FF] rounded-lg">
                  <img
                    src={Logo}
                    alt="ABM Group Logo"
                    className="w-16 h-16 object-contain"
                  />
                </div>
              </div>
              <div>
                <div className="flex items-center gap-1">
                  <span className="text-2xl font-bold" style={{ color: colors.nearBlack }}>ABM</span>
                  <span className="text-lg font-medium" style={{ color: colors.oliveBrown }}>GROUP</span>
                  <span className="text-lg font-medium" style={{ color: colors.oliveBrown }}>ONE</span>
                </div>
                <div className="flex gap-1 mt-0.5">
                  <span className="w-2 h-2 rounded-full" style={{ backgroundColor: colors.pinkMagenta }}></span>
                  <span className="w-2 h-2 rounded-full" style={{ backgroundColor: colors.goldenYellow }}></span>
                  <span className="w-2 h-2 rounded-full" style={{ backgroundColor: colors.freshGreen }}></span>
                  <span className="w-2 h-2 rounded-full" style={{ backgroundColor: colors.brightBlue }}></span>
                  <span className="w-2 h-2 rounded-full" style={{ backgroundColor: colors.deepOrange }}></span>
                </div>
              </div>
            </div>
            
            <p className="text-sm mb-4" style={{ color: colors.oliveBrown }}>
              India's most transparent and rewarding Hybrid MLM platform with Matrix + Generation plan.
            </p>
            
            {/* Contact Info */}
            <div className="space-y-3 text-sm">
              <div className="flex items-center gap-3">
                <div className="w-8 h-8 rounded-full flex items-center justify-center" 
                  style={{ backgroundColor: colors.deepOrange + '20' }}>
                  <FaPhone style={{ color: colors.deepOrange }} />
                </div>
                <div>
                  <a href="tel:8887355992" className="hover:underline font-medium" style={{ color: colors.nearBlack }}>
                    +91 8887355992
                  </a>
                </div>
              </div>
              
              <div className="flex items-center gap-3">
                <div className="w-8 h-8 rounded-full flex items-center justify-center" 
                  style={{ backgroundColor: colors.freshGreen + '20' }}>
                  <FaEnvelope style={{ color: colors.freshGreen }} />
                </div>
                <div>
                  <a href="mailto:support.abmgroupone@gmail.com" className="hover:underline" style={{ color: colors.oliveBrown }}>
                    support.abmgroupone@gmail.com
                  </a>
                </div>
              </div>
              
              <div className="flex items-center gap-3">
                <div className="w-8 h-8 rounded-full flex items-center justify-center" 
                  style={{ backgroundColor: colors.brightBlue + '20' }}>
                  <FaMapMarkerAlt style={{ color: colors.brightBlue }} />
                </div>
                <span style={{ color: colors.oliveBrown }}>Prayagraj Uttar Pradesh, India, 212305</span>
              </div>
              
              <div className="flex items-center gap-3">
                <div className="w-8 h-8 rounded-full flex items-center justify-center" 
                  style={{ backgroundColor: colors.goldenYellow + '20' }}>
                  <FaClock style={{ color: colors.goldenYellow }} />
                </div>
                <span style={{ color: colors.oliveBrown }}>Mon-Sat: 10AM - 6PM</span>
              </div>
            </div>
          </div>

          {/* Quick Links - Column 2 */}
          <div>
            <h4 className="font-bold text-lg mb-6 relative" style={{ color: colors.nearBlack }}>
              Quick Links
              <span className="absolute bottom-0 left-0 w-12 h-0.5" style={{ backgroundColor: colors.deepOrange }}></span>
            </h4>
            <ul className="space-y-3">
              {[
                { name: 'Home', path: '/' },
                { name: 'Features', path: '/features' },
                { name: 'About Us', path: '/about' },
                { name: 'Contact Us', path: '/contact' },
                { name: 'FAQs', path: '/faq' },
                { name: 'Blog', path: '/blog' }
              ].map((link, idx) => (
                <li key={idx}>
                  <Link 
                    to={link.path}
                    className="text-sm hover:translate-x-2 inline-block transition-all duration-300 flex items-center gap-2"
                    style={{ color: colors.oliveBrown }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.color = colors.deepOrange;
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.color = colors.oliveBrown;
                    }}
                  >
                    <span className="w-1 h-1 rounded-full" style={{ backgroundColor: colors.deepOrange }}></span>
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Partnership - Column 3 */}
          <div>
            <h4 className="font-bold text-lg mb-6 relative" style={{ color: colors.nearBlack }}>
              Partnership
              <span className="absolute bottom-0 left-0 w-12 h-0.5" style={{ backgroundColor: colors.freshGreen }}></span>
            </h4>
            <ul className="space-y-3">
              {[
                { name: 'Share Partner', path: '/register/share-partner', icon: FaShareAlt, color: colors.deepOrange },
                { name: 'Product Partner', path: '/register/product-partner', icon: FaProductHunt, color: colors.freshGreen },
                { name: 'My Pickup Center', path: '/pickup-center', icon: FaStore, color: colors.darkBrown },
                { name: 'Mobile Store', path: '/mobile-store', icon: FaTruck, color: colors.freshGreen },
                { name: 'Delivery Boy', path: '/delivery-boy', icon: FaMobile, color: colors.brightBlue },
                { name: 'Become a Distributor', path: '/distributor', icon: FaUsers, color: colors.pinkMagenta }
              ].map((link, idx) => (
                <li key={idx}>
                  <Link 
                    to={link.path}
                    className="text-sm hover:translate-x-2 inline-block transition-all duration-300 flex items-center gap-2"
                    style={{ color: colors.oliveBrown }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.color = link.color;
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.color = colors.oliveBrown;
                    }}
                  >
                    <link.icon style={{ color: link.color }} />
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Income Plans - Column 4 */}
          <div>
            <h4 className="font-bold text-lg mb-6 relative" style={{ color: colors.nearBlack }}>
              Income Plans
              <span className="absolute bottom-0 left-0 w-12 h-0.5" style={{ backgroundColor: colors.goldenYellow }}></span>
            </h4>
            <ul className="space-y-3">
              {[
                { name: 'Retail Profit (10% to 25%)', icon: FaStar, color: colors.freshGreen },
                { name: 'Direct Bonus (5%)', icon: FaStar, color: colors.freshGreen },
                { name: 'Matrix Income (15%)', icon: FaChartLine, color: colors.brightBlue },
                { name: 'Generation Income (11%)', icon: FaUsers, color: colors.pinkMagenta },
                { name: 'Active Member Reward (10%)', icon: FaUsers, color: colors.pinkMagenta },
                { name: 'Reward Tour Bonus (3%)', icon: FaTrophy, color: colors.goldenYellow },
                { name: 'Car Bonus (4%)', icon: FaCar, color: colors.deepOrange },
                { name: 'Royalty Bonus (2%)', icon: FaGift, color: '#800080' }
              ].map((item, idx) => (
                <li key={idx} className="flex items-center gap-2 text-sm" style={{ color: colors.oliveBrown }}>
                  <item.icon style={{ color: item.color }} />
                  {item.name}
                </li>
              ))}
            </ul>
          </div>

          {/* Wallet & Support - Column 5 */}
          <div>
            <h4 className="font-bold text-lg mb-6 relative" style={{ color: colors.nearBlack }}>
              Support
              <span className="absolute bottom-0 left-0 w-12 h-0.5" style={{ backgroundColor: colors.brightBlue }}></span>
            </h4>
            <ul className="space-y-3">
              {[
                { name: '3-Tier Wallet', icon: FaWallet, color: colors.deepOrange },
                { name: 'KYC Verification', icon: FaShieldAlt, color: colors.freshGreen },
                { name: 'GST Billing', icon: FaQrcode, color: colors.brightBlue },
                { name: '24/7 Support', icon: FaHeadset, color: colors.pinkMagenta },
                { name: 'Privacy Policy', path: '/privacy', icon: FaCheckCircle, color: colors.oliveBrown },
                { name: 'Terms & Conditions', path: '/terms', icon: FaCheckCircle, color: colors.oliveBrown }
              ].map((item, idx) => (
                <li key={idx}>
                  {item.path ? (
                    <Link 
                      to={item.path}
                      className="text-sm hover:translate-x-2 inline-block transition-all duration-300 flex items-center gap-2"
                      style={{ color: colors.oliveBrown }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.color = item.color;
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.color = colors.oliveBrown;
                      }}
                    >
                      <item.icon style={{ color: item.color }} /> {item.name}
                    </Link>
                  ) : (
                    <span className="text-sm flex items-center gap-2" style={{ color: colors.oliveBrown }}>
                      <item.icon style={{ color: item.color }} /> {item.name}
                    </span>
                  )}
                </li>
              ))}
            </ul>

            {/* App Downloads */}
            <div className="mt-6">
              <h5 className="font-semibold text-sm mb-3" style={{ color: colors.nearBlack }}>
                Download App
              </h5>
              <div className="flex gap-2">
                <a 
                  href="#" 
                  className="flex-1 bg-black text-white px-3 py-2 rounded-lg flex items-center gap-2 text-xs hover:bg-gray-800 transition transform hover:-translate-y-1"
                >
                  <FaApple className="text-lg" />
                  <div>
                    <div className="text-[10px] opacity-80">Download on</div>
                    <div className="font-bold">App Store</div>
                  </div>
                </a>
                <a 
                  href="#" 
                  className="flex-1 bg-black text-white px-3 py-2 rounded-lg flex items-center gap-2 text-xs hover:bg-gray-800 transition transform hover:-translate-y-1"
                >
                  <FaGooglePlay className="text-lg" />
                  <div>
                    <div className="text-[10px] opacity-80">Get it on</div>
                    <div className="font-bold">Google Play</div>
                  </div>
                </a>
              </div>
            </div>
          </div>
        </div>


        {/* ===== BOTTOM BAR ===== */}
        <div className="border-t border-gray-200 mt-8 pt-6">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-xs max-w-7xl mx-auto">
            
            {/* Copyright */}
            <p style={{ color: colors.oliveBrown }}>
              © {currentYear} ABM Group One. All rights reserved.
            </p>

            {/* Legal Links */}
            <div className="flex gap-4">
              <Link to="/privacy" className="hover:underline transition" style={{ color: colors.oliveBrown }}
                onMouseEnter={(e) => e.currentTarget.style.color = colors.deepOrange}
                onMouseLeave={(e) => e.currentTarget.style.color = colors.oliveBrown}
              >
                Privacy Policy
              </Link>
              <Link to="/terms" className="hover:underline transition" style={{ color: colors.oliveBrown }}
                onMouseEnter={(e) => e.currentTarget.style.color = colors.deepOrange}
                onMouseLeave={(e) => e.currentTarget.style.color = colors.oliveBrown}
              >
                Terms of Use
              </Link>
              <Link to="/refund" className="hover:underline transition" style={{ color: colors.oliveBrown }}
                onMouseEnter={(e) => e.currentTarget.style.color = colors.deepOrange}
                onMouseLeave={(e) => e.currentTarget.style.color = colors.oliveBrown}
              >
                Refund Policy
              </Link>
              <Link to="/disclaimer" className="hover:underline transition" style={{ color: colors.oliveBrown }}
                onMouseEnter={(e) => e.currentTarget.style.color = colors.deepOrange}
                onMouseLeave={(e) => e.currentTarget.style.color = colors.oliveBrown}
              >
                Disclaimer
              </Link>
            </div>

            {/* Made with love */}
            <p className="flex items-center gap-1" style={{ color: colors.oliveBrown }}>
              Made with <FaHeart style={{ color: colors.pinkMagenta }} /> in India
            </p>
          </div>

          {/* Compliance Note */}
          <div className="mt-4 text-center text-xs max-w-4xl mx-auto px-4" style={{ color: colors.oliveBrown }}>
            <p>
              *Terms and Conditions apply. This is a legitimate MLM business opportunity. 
              All payments are subject to 5% TDS as per government norms. 
              GST bills provided for every purchase. 7 days return policy applicable.
            </p>
          </div>
        </div>
      </div>

      {/* ===== FLOATING ACTION BUTTONS ===== */}
      
      {/* WhatsApp Button */}
      <a
        href="https://wa.me/918887355992"
        target="_blank"
        rel="noopener noreferrer"
        className="fixed bottom-6 right-6 w-14 h-14 rounded-full text-white flex items-center justify-center text-3xl shadow-lg hover:shadow-xl transition-all duration-300 transform hover:scale-110 z-50 animate-bounce"
        style={{ backgroundColor: '#25D366' }}
      >
        <FaWhatsapp />
      </a>

      {/* Back to Top Button */}
      <button
        onClick={scrollToTop}
        className="fixed bottom-6 left-6 w-10 h-10 rounded-full text-white flex items-center justify-center shadow-lg hover:shadow-xl transition-all duration-300 transform hover:scale-110 z-50"
        style={{ backgroundColor: colors.navyBlue }}
      >
        ↑
      </button>

      {/* ===== CERTIFICATION BADGE ===== */}
      <div className="fixed bottom-6 left-1/2 transform -translate-x-1/2 hidden lg:block z-50">
        <div className="bg-white rounded-full shadow-lg px-4 py-2 flex items-center gap-2 border border-gray-200">
          <FaShieldAlt style={{ color: colors.freshGreen }} />
          <span className="text-xs font-medium" style={{ color: colors.nearBlack }}>ISO 9001:2015 Certified</span>
        </div>
      </div>
    </footer>
  );
}

export default Footer;